document.addEventListener("DOMContentLoaded", function() {
  const slides = document.querySelectorAll('.home-hero__slide');
  if (slides.length <= 1) return;

  let currentIndex = 0;
  const slideDuration = 5000; // 画像1枚の表示時間（ミリ秒）

  setInterval(() => {
    // 古い.prevを削除
    slides.forEach(slide => slide.classList.remove('prev'));
    
    // 現在の.activeを.prevに変更（背面に回して表示を維持）
    slides[currentIndex].classList.remove('active');
    slides[currentIndex].classList.add('prev');
    
    // 次のスライドへ
    currentIndex = (currentIndex + 1) % slides.length;
    
    // 新しいスライドを.activeにして前面でフェードインさせる
    slides[currentIndex].classList.add('active');
  }, slideDuration);
});


document.addEventListener('DOMContentLoaded', () => {
  // テキストを置換する関数
  const replaceSubscriptionText = () => {
    const targetSpans = document.querySelectorAll('.title_and_price_wrapper span');
    
    // 該当要素がない場合は処理を終了（他ページでのエラー防止）
    if (!targetSpans.length) return;

    targetSpans.forEach(span => {
      if (span.textContent.includes('ごとに配達')) {
        span.textContent = span.textContent.replace('ごとに配達', 'ごとに更新');
      }
    });
  };

  // 初回実行
  replaceSubscriptionText();

  // DOMの変更を監視し、アプリブロックが再描画された際も置換を適用する
  const observer = new MutationObserver(() => {
    replaceSubscriptionText();
  });

  // body全体を監視対象とする（ウィジェットの遅延読み込み対策）
  observer.observe(document.body, { childList: true, subtree: true });
});